import { Box } from '@material-ui/core';
import { ReactElement, useMemo } from 'react';
import { Control, Path, PathValue } from 'react-hook-form';
import {
	getSchoolTvIdMatchArray,
	getVimeoIdMatchArray,
	getYouTubeIdMatchArray,
	isCasperAssetId
} from '../../../utils';
import { TextInputField, VideoPlayer } from '../../atoms';

import './video-input-field.styles.scss';

export interface IVideoInputFieldProps<T> {
	videoUrl?: string;
	control: Control<T>;
	name: Path<T>;
	label?: string;
	placeholder?: string;
	required?: boolean | undefined;
	fullWidth?: boolean | undefined;
	valid?: boolean | undefined;
	hideLabel?: boolean;
}

export function VideoInputField<T>(
	props: IVideoInputFieldProps<T>
): ReactElement {
	const {
		videoUrl,
		control,
		name,
		label,
		placeholder,
		required,
		fullWidth,
		valid,
		hideLabel
	} = props;

	const isValid: boolean = useMemo(() => {
		if (videoUrl && isValidUrl(videoUrl)) return true;
		return false;
	}, [videoUrl]);

	function validateUrl(value: PathValue<T, Path<T>>) {
		if (typeof value === 'string') {
			if (value && isValidUrl(value)) return true;
		}
		return false;
	}

	function isValidUrl(url: string): boolean {
		return (
			isValidVimeoUrl(url) ||
			isValidYouTubeUrl(url) ||
			isCasperAssetId(url) ||
			isValidSchoolTvValue(url)
		);
	}

	function isValidYouTubeUrl(url: string): boolean {
		return getYouTubeIdMatchArray(url) !== null;
	}

	function isValidVimeoUrl(url: string): boolean {
		return getVimeoIdMatchArray(url) !== null;
	}

	function isValidSchoolTvValue(embedCode: string): boolean {
		return getSchoolTvIdMatchArray(embedCode) !== null;
	}

	return (
		<Box className="video-input-field">
			<TextInputField
				name={name}
				control={control}
				label={hideLabel ? undefined : label}
				placeholder={placeholder}
				required={required}
				fullWidth={fullWidth}
				validate={{ correctFormat: (value) => validateUrl(value) }}
				valid={valid}
			/>

			{videoUrl && videoUrl.length > 0 && isValid && (
				<VideoPlayer videoUrl={videoUrl} />
			)}
		</Box>
	);
}
